import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import PartnerEdit from './PartnerEdit.page';

import {
  getPartnerDetail,
  updatePartner,
  updatePartnerEditStep,
} from '../../redux/actions/delivery';

const mapStateToProps = state => ({
  getPartnerDetailLoading: state.delivery.getPartnerDetailLoading,
  loading: state.delivery.loading,
  partnerDetail: state.delivery.partnerDetail,
  partnerEditStep: state.delivery.partnerEditStep,
});

const mapDispatchToProps = {
  getPartnerDetail,
  updatePartner,
  updatePartnerEditStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PartnerEdit));
